import { render, staticRenderFns } from "./NoticeView.vue?vue&type=template&id=2f343ef5&scoped=true"
import script from "./NoticeView.vue?vue&type=script&lang=js"
export * from "./NoticeView.vue?vue&type=script&lang=js"
import style0 from "./NoticeView.vue?vue&type=style&index=0&id=2f343ef5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f343ef5",
  null
  
)

export default component.exports